export { InfoTooltip } from "./info-tooltip";
export type { IInfoTooltipProps } from "./info-tooltip";
